import React, { useState, useEffect } from "react";
// import { useTypewriter } from "react-typewriter-plus";
// import TypeIt from "typeit-react";
import styled from "styled-components";
import bg1 from "./images/十周年@2x.png";
import bridge from '@/config/JSbridge'
import bwmodel from "@/config/bwmodel";
import Card from "./Card";
const html = `
<div>
<span style='display:block;margin-bottom: 5px;'>亲爱的市值风云朋友：</span>
<p>
    自2016年4月26日成立至今，市值风云已走过整整十载。十年深耕，一路同行，我们向前的每一步，都离不开您的信任、支持与陪伴。在此，向您致以最诚挚的感谢！
 </p>
 <p>
  下一个十年，愿我们继续携手并进，共同迎接A股坚实有力的慢牛行情，愿大家投资成功、收益长虹，一路向阳，未来可期！</p>
<div>
<div style='text-align: right; margin-top: 5px;'>市值风云创始人：杨峰 </div>
<div style='text-align: right;'>2026年4月</div>
`;
export const isStorm = bwmodel.app === "storm";


const App = ({token}) => {

  const [isVisible, setIsVisible] = useState(true); // 是否显示当前页面
  const [shouldFade, setShouldFade] = useState(false); // 是否 动画隐藏当前页面
  const [isWrite, setIsWrite] = useState(true); // 是否正在打字
 const handleLogin = (cb) => {
        bridge.callHandler(
          'nativeEvent',
          {
            event: 'login',
            params: {
              refreshOnBack: true
            }
          },
          () => {}
        );
      }   
  const handleRemove = () => {

    // 判断是否登陆
    if(!token) {
      handleLogin()
      return;
    }

    setShouldFade(true);
  };

  useEffect(() => {
     // 判断是否登陆
     const shouldFade = localStorage.getItem('active_210_shouldFade');
    if(shouldFade) {
      // setShouldFade(false);
      setIsWrite(false)
    }
 
        // 1. 触发淡出效果
    localStorage.setItem('active_210_shouldFade', 'true');
     // const shouldFade = localStorage.getItem('active_210_shouldFade');
    
    // if(token) {
      
    //   setIsVisible(true);
    //   return;
    // }
   
    // const shouldFade = localStorage.getItem('active_210_shouldFade');
    if (shouldFade) {
      // setIsVisible(false);
    }
  }, []);
  const onTransitionEnd = () => {
    // 2. 动画结束后，彻底移除元素
    setIsVisible(false);
  };
  // const htmlText = useTypewriter(html, {
  //   speed: 20,
  //   cursor: false,
  //   type: "html",
  // });
  // console.log(htmlText);
  
 
    if (!isVisible) return null;  // 完全从 DOM 中移除

  return (
    // isStorm
    <Content onTransitionEnd={onTransitionEnd} className={`${shouldFade ? 'shouldFade' : ''} ${isStorm ? 'mt40' : ''}`}>
      <div className={isStorm? 'content mt40': 'content'} >
       
        {isWrite ? 
        <Card/> : 
              <div 
              dangerouslySetInnerHTML={{ __html: html }} 
            />

        }
      </div>   

      {
        isWrite?  <div className="btn show-after-3s" onClick={()=>handleRemove()}> 
        <img src={require('./images/Group_btn.png')} alt="logo" />
      </div>:
       <div className="btn show" onClick={()=>handleRemove()}> 
        <img src={require('./images/Group_btn.png')} alt="logo" />
      </div>
      }   
     
    </Content>
  );
};

export default App;
const Content = styled.div`
@keyframes showAfterDelay {
  0%, 99% {
    opacity: 0;
    visibility: hidden;
  }
  100% {
    opacity: 1;
    visibility: visible;
  }
}
  transition: opacity 1s ease;
  opacity: 1;
  &.shouldFade {
      opacity: 0;
  }
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
 
  height: calc(100vh);
  border-radius: 0px 0px 0px 0px;
  background-color: #a2060d;
  border-radius: 0px 0px 0px 0px;
  background-image: url(${bg1});
  background-size: 100% calc(100vh - 0px);
  background-position: center 0px;
  background-repeat: no-repeat;
  font-weight: normal;
  font-size: 3.46vw;
  color: #320303;
  box-sizing: border-box;
  &.mt40 {
     padding-top: 40px;
       background-size: 100% calc(100vh - 40px);
      background-position: center 40px;
  }
  img {
    width: 100vw;
    height: 100vh;
    use-select: none;
  }
  p {
    line-height: 1.7;
    padding: 0;
    margin: 0;
    text-indent: 2em; 
  }
  .content {
    padding: 33vh 13vw 10vw;
    padding-top: calc(33vh + 40px);
    line-height: 1.7;
    min-height: 85px;
    font-size: 1.7vh;
    &.mt40 {
      padding-top: calc(33vh );
    }
  }
    
  .btn {
    position: absolute;
    bottom: 10vw;
    left: 50%;
    transform: translateX(-50%);
    height: 45px;
    img {
      width: 55vw;
      height: 100%;
    }
      opacity: 0;
  visibility: hidden;
  
  &.show {
     opacity: 1;
  visibility: visible;
  }
    &.show-after-3s {
    transition: opacity 1s ease, visibility 0.3s ease;
    animation: showAfterDelay 3s forwards;
}
  }
`;


// WEBPACK FOOTER //
// ./src/views/activity_210/PureReactTypewriter.js